<div class="container-fluid campaign-background pt-0">
    <app-trial-license-warning></app-trial-license-warning>
    <lib-campaigns></lib-campaigns>
</div>  

<div class="content-section">
    <div class="title-div">
        <div class="col p-0 d-flex justify-content-between align-items-center changeInstitution">
            <div class="col-11 p-0">

                <a class="back_bd" (click)=backToManageUser()>
                    <img class="svg mr-2" src="assets/ph-bhp-layout/svg/back.svg" /> {{
                    translationKeys.SOPObservation.Back | translate}}</a>
                <h2 class="background_title">{{this.userid ? ('USER_MANAGEMENT.EDIT_USER' | translate) :
                    ('USER_MANAGEMENT.ADD_USER' | translate) }}</h2>

            </div>

            <div class="col-auto d-flex justify-content-md-end justify-content-sm-start">
                <div class="row institution-name" *ngIf="institutionName">
                    <img alt="Institution" class="mr-2" src="assets/img/menuActive/Institution.svg">
                    <p class="m-0"> {{institutionName | translate | labelSanitizer}}</p>
                </div>
                <div class="col-auto institution-name pl-0">
                    <!-- <img alt="Institution" src="assets/img/svg/icon-help.svg"> -->
                </div>
            </div>

        </div>
    </div>
    <div class="container-fluid alone ">
        <form class="form-container" name="addUserFormGeneralInfo" [formGroup]="addUserFormGeneralInfo">
            <div class="my-4">
                <div class="row">
                    <div class="col-md-4 col-sm-12">
                        <div class="form-group">
                            <mat-form-field class="example-full-width">
                                <mat-label>{{ translationKeys.ProfileDetails.Name | translate }} <label
                                        class="mandatory">*</label></mat-label>
                                <input matInput inputSanitizer type="text" formControlName="name" maxlength="40"
                                    name="name" placeholder="{{'USER_MANAGEMENT.ENTER_NAME' | translate}}"
                                    [ngClass]="{'is-invalid':addUserFormGeneralInfo.get('name').errors && (addUserFormGeneralInfo.get('name').touched || addUserFormGeneralInfo.get('name').dirty || submitted)}">
                                <mat-hint align="end">({{'INSTITUTION_MANAGEMENT.MAX' | translate}} 40)</mat-hint>
                            </mat-form-field>

                        </div>
                    </div>
                    <div class="col-md-4 col-sm-12">
                        <div class="form-group">
                            <mat-form-field class="example-full-width">
                                <mat-label>{{ translationKeys.ProfileDetails.Email | translate }} <label
                                        class="mandatory">*</label></mat-label>
                                <input matInput inputSanitizer type="email" name="email" maxlength="100"
                                    formControlName="email" (focusout)="userEmailExist()"
                                    pattern="^[A-Za-z0-9._%+-]+@[a-z0-9.-]+(\.[a-z]{2,4})+$"
                                    [ngClass]="{'is-invalid':addUserFormGeneralInfo.get('email').errors && (addUserFormGeneralInfo.get('email').touched || addUserFormGeneralInfo.get('email').dirty || submitted)}"
                                    placeholder="{{'USER_MANAGEMENT.ENTER_MAIL_ADDRESS' | translate}}">
                                <mat-hint align="end">({{'INSTITUTION_MANAGEMENT.MAX' | translate}} 100)</mat-hint>
                            </mat-form-field>

                        </div>
                    </div>
                    <div class="col-md-4 col-sm-12">
                        <div class="form-group">
                            <mat-form-field class="example-full-width">
                                <mat-label>{{ translationKeys.Authorization.Username | translate }} <label
                                        class="mandatory">*</label></mat-label>
                                <input matInput inputSanitizer type="text" maxlength="25" name="username"
                                    formControlName="username" (keyup)="checkUserName($event.target.value)"
                                    (focusout)="userNameExist()"
                                    [ngClass]="{'is-invalid':!admitedUserName || !uNameExist || (addUserFormGeneralInfo.get('username').errors && (addUserFormGeneralInfo.get('username').touched || addUserFormGeneralInfo.get('username').dirty || submitted))}"
                                    placeholder="{{'USER_MANAGEMENT.ENTER_USERNAME' | translate}}">
                                <mat-hint>{{ 'USER_MANAGEMENT.GENERATED_PASSWORD_SEND_TO_REGISTERED_MAIL' | translate
                                    }}</mat-hint>
                            </mat-form-field>

                            <div class="invalid-feedback usernameErrorDiv"
                                *ngIf="!admitedUserName || !uNameExist || (addUserFormGeneralInfo.get('username').errors && (addUserFormGeneralInfo.get('username').touched ||addUserFormGeneralInfo.get('username').dirty  || submitted))">
                                <div *ngIf="!uNameExist">
                                    {{ 'ERROR_MESSAGES.USERNAME_TAKEN' | translate }}
                                </div>
                                <div *ngIf="!admitedUserName" class="admitedCharacters">
                                    <p>{{translationKeys.ErrorMessages.AdmitedUserName | translate}}</p>
                                    <p>• {{translationKeys.ErrorMessages.AdmitedUserNameLetters | translate}}</p>
                                    <p>• {{translationKeys.ErrorMessages.AdmitedUserNameNumbers | translate}}</p>
                                    <p>• {{translationKeys.ErrorMessages.AdmitedUserNameSpecial | translate}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-12">
                        <div class="form-group">
                            <div class="dropdown dropdown-bhp" [ngClass]="{'dropdown-invalid': !isRoleValid()}">
                                <div class="dropdown-container-input" data-toggle="dropdown" aria-expanded="false">
                                    <input formControlName="roleId" hidden>
                                    <input *ngIf=" addUserFormGeneralInfo.get('roleId').value !== '' "
                                        class="dropdown-toggle" type="text" formControlName="roleName" required readonly
                                        [ngClass]="{'is-invalid':addUserFormGeneralInfo.get('roleId').errors && (addUserFormGeneralInfo.get('roleName').touched || addUserFormGeneralInfo.get('roleName').dirty || addUserFormGeneralInfo.submitted )}">
                                    <input
                                        *ngIf=" addUserFormGeneralInfo.get('roleId').value === '' || addUserFormGeneralInfo.get('roleId').value === undefined "
                                        class="dropdown-toggle" type="text"
                                        [value]=" 'USER_MANAGEMENT.SELECT_ROLE' | translate" required readonly
                                        [ngClass]="{'is-invalid':addUserFormGeneralInfo.get('roleId').errors && (addUserFormGeneralInfo.get('roleName').touched || addUserFormGeneralInfo.get('roleName').dirty || addUserFormGeneralInfo.submitted)}">
                                    <span class="label-dropdown">{{ translationKeys.ProfileDetails.Role | translate }}
                                        <span class="mandatory">*</span></span>
                                    <img class="dropdown-arrow" src="assets/icons/arrowDropdownOutlined.svg" />
                                </div>
                                <ul class="dropdown-menu">
                                    <li class="dropdown-item" (click)="onRoleChange(0)" value="">{{
                                        'USER_MANAGEMENT.SELECT_ROLE' | translate }}</li>
                                    <li class="dropdown-item" (click)="onRoleChange(roleAndInstitutions.role.roleId)"
                                        *ngFor='let roleAndInstitutions of filterRoleOptions();let i = index'
                                        value="{{roleAndInstitutions.role.roleId}}">
                                        {{roleAndInstitutions.role.roleName | translate}}
                                    </li>
                                </ul>
                            </div>
                        </div>

                    </div>
                    <div class="col-md-4 col-sm-12">
                        <div class="form-group">
                            <label>{{ 'INSTITUTION_MANAGEMENT.STATUS' | translate }}</label><span
                                class="mandatory">*</span>
                            <label class="switch mb-4 mt-2 d-block">

                                <mat-slide-toggle [id]="'institution-status-slider'" color="primary" name="isActive"
                                    formControlName="isActive">
                                    <span *ngIf="addUserFormGeneralInfo.get('isActive').value">{{
                                        'INSTITUTION_MANAGEMENT.ACTIVE' | translate }}</span>
                                    <span *ngIf="!addUserFormGeneralInfo.get('isActive').value">{{
                                        'INSTITUTION_MANAGEMENT.IN_ACTIVE' | translate }}</span>
                                </mat-slide-toggle>
                            </label>
                        </div>
                    </div>

                    <div class="col-md-4 col-sm-12" *ngIf="addUserFormGeneralInfo.get('roleId').value === 5">
                        <div class="form-group">
                            <label>{{ 'INSTITUTION_MANAGEMENT.HAS_EVALUATION_ACCESSIBLE' | translate }}</label><span
                                class="mandatory">*</span>
                            <label class="switch mb-4 mt-2 d-block">

                                <mat-slide-toggle [id]="'evaluation-status-slider'" color="primary"
                                    name="isEvaluationAccessible" formControlName="isEvaluationAccessible">
                                    <span *ngIf="addUserFormGeneralInfo.get('isEvaluationAccessible').value">{{
                                        'INSTITUTION_MANAGEMENT.ACTIVE' | translate }}</span>
                                    <span *ngIf="!addUserFormGeneralInfo.get('isEvaluationAccessible').value">{{
                                        'INSTITUTION_MANAGEMENT.IN_ACTIVE' | translate }}</span>
                                </mat-slide-toggle>
                            </label>
                        </div>
                    </div>

                    <div class="col-md-4 col-sm-12">
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4 col-sm-12">
                        <div class="form-group"
                            *ngIf="addUserFormGeneralInfo.value.roleId != '' && institutionId == null">
                            <label
                                *ngIf='addUserFormGeneralInfo.get("roleId").value == 4 || addUserFormGeneralInfo.get("roleId").value == 5'><label>{{
                                    translationKeys.ProfileDetails.InstitutionName | translate }}</label><span
                                    class="mandatory">*</span></label>
                            <label *ngIf='addUserFormGeneralInfo.get("roleId").value == 3'><label>{{
                                    'INSTITUTION_MANAGEMENT.GROUP_NAME' | translate }}</label><span
                                    class="mandatory">*</span></label>
                            <div class="checkbox-container">
                                <div class="row mb-3">
                                    <div class="col-8">
                                        <input inputSanitizer class="form-control search-input"
                                            placeholder="{{ 'INSTITUTION_MANAGEMENT.SEARCH' | translate }}..."
                                            [(ngModel)]="searchText" [ngModelOptions]="{standalone: true}">
                                    </div>
                                    <div class="col-4 p-0">
                                        <div class="mt-2" *ngIf="isMultiselect">
                                            <input type="checkbox" class="custom-control-input" id="selectAll"
                                                [ngModelOptions]="{standalone: true}" (change)="checkAll($event)"
                                                [(ngModel)]="selectins">
                                            <label for="selectAll">{{ 'INSTITUTION_MANAGEMENT.SELECT_ALL' | translate
                                                }}</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="checkbox-container-list">
                                    <div class="mb-2" *ngFor='let institution of institutionsList | search:searchText'>
                                        <input type="checkbox" class="custom-control-input"
                                            (change)="checkValue(institution,$event)" *ngIf="isMultiselect"
                                            name="customCheck-{{institution.institutionID}}"
                                            id="customCheck-{{institution.institutionID}}"
                                            [(ngModel)]="institutionChecked[institution.institutionID]"
                                            [ngModelOptions]="{standalone: true}">

                                        <input type="radio" class="custom-control-input"
                                            (change)="checkValueradio(institution)" *ngIf="!isMultiselect"
                                            name="customCheck-{{institution.institutionID}}"
                                            id="customCheck-{{institution.institutionID}}"
                                            [(ngModel)]="institutionRadio" [value]="institution.institutionID"
                                            [ngModelOptions]="{standalone: true}">
                                        <label [ngClass]="(isMultiselect)?'':''"
                                            for="customCheck-{{institution.institutionID}}">{{institution.institutionName}}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-end buttons-box">
                    <button (click)="cancelModal()" class="btn-cancel-bd separate-button">{{
                        translationKeys.Authorization.Cancel | translate }}</button>
                    <button (click)="submitUser(addUserFormGeneralInfo.value)"
                        class="btn-continue-bordered-bd mr-4 align-button">{{ translationKeys.Authorization.Save |
                        translate }}</button>
                </div>
            </div>
        </form>
    </div>
</div>





<!-- Modal - Add User Confirmation -->
<ng-template #cancelmodal>
    <div class="modal-header justify-content-between align-items-center mb-4">
        <h5 class="modal-title">{{ translationKeys.InstitutionManagement.Confirmation | translate }}</h5>
        <a class="cursor" data-dismiss="modal" (click)="modalRef.hide()"><img
                src="assets/ph-bhp-layout/svg/remove.svg"></a>
    </div>
    <div class="modal-body">
        <p>{{'INSTITUTION_MANAGEMENT.INFORMATION_UNSAVED_CHANGES_LOST_AFTER_LEAVING' | translate}}</p>
    </div>
    <div class="modal-footer">
        <button (click)="modalRef.hide()" class="btn btn-cancel-bordered-bd separate-buttons">{{
            'LAYOUT_MODULE.STAY' | translate }}</button>
        <button (click)="CancelUser();modalRef.hide()" class="btn btn-continue-bordered-bd">{{
            'LAYOUT_MODULE.LEAVE' | translate }}</button>
    </div>
</ng-template>


<div class="side-appbar">
    <div class="container-fluid">
    </div>
</div>

<div id="page_overlay"></div>